"use strict";

var Wrapper = require('../../products/components/Wrapper');

var ThickWrapper = require('../../products/components/ThickWrapper');

var Inventory = require('./Inventory');

var getComposables = require('../PrintingDetails/componentComposables');

function inventoryGlueDots(comps, date, options) {
  var components = comps.filter(function (comp) {
    return Object.prototype.isPrototypeOf.call(Wrapper.prototype, comp) || Object.prototype.isPrototypeOf.call(ThickWrapper.prototype, comp);
  });
  var total = 0;
  var componentSettings = options.printers.printingPlus.components;
  components.forEach(function (component) {
    var component_type = component.type;
    var component_options = componentSettings[component_type] || componentSettings["default"];
    var field = 'glueDotsQuantity';
    var quantity = getComposables(field, component_options[field]).reduce(function (accumulator, fn) {
      return fn(accumulator, {}, {}, component, component_options, options);
    }, 0);
    total += quantity;
  });

  if (total) {
    return [new Inventory({
      quantity: total,
      date: date,
      name: 'Glue Dots',
      key: 'glue_dots',
      category: 'glue_dots',
      unit: 'each'
    })];
  }

  return [];
}

module.exports = inventoryGlueDots;